import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage/local-storage.service';
import { inject } from '@angular/core';

export const corporateGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  if (localStorageService.getIsCorporateRole()) {
    console.log(localStorageService.getIsCampaignManager())
    return true;
  } else {
    return false;
  }
};
